import { ENTERPRISE, STARTER, tabIdToProductLevels } from '../constants/Tabs';
export const isValidTab = tab => {
  return tab === STARTER || tab === ENTERPRISE;
};
export const getProductLevelsForTab = tab => {
  if (!tab) {
    return ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
  }
  return tabIdToProductLevels[tab];
};
export const filterProductsConfigByTab = (fullConfig, tab) => {
  if (!tab) {
    return fullConfig;
  }
  const allowedLevels = getProductLevelsForTab(tab);

  // PROFESSIONAL and ENTERPRISE are always required by HubMerchCardLayoutUI
  // FREE and STARTER are optional based on tab
  const shouldIncludeFree = allowedLevels.includes('FREE');
  const shouldIncludeStarter = allowedLevels.includes('STARTER');
  const filteredConfig = {
    PROFESSIONAL: fullConfig.PROFESSIONAL,
    ENTERPRISE: fullConfig.ENTERPRISE
  };

  // Add FREE if it's allowed for this tab and exists in fullConfig
  if (shouldIncludeFree && fullConfig.FREE) {
    filteredConfig.FREE = fullConfig.FREE;
  }

  // Add STARTER if it's allowed for this tab and exists in fullConfig
  if (shouldIncludeStarter && fullConfig.STARTER) {
    filteredConfig.STARTER = fullConfig.STARTER;
  }
  return filteredConfig;
};